import m from "mithril"
import { MithrilTsxComponent } from "mithril-tsx-component"
import * as State from "../state"
import { ActionBarMobile, ActionBarDesktop } from "./actionBar"
import "./actions.scss"
import { cleanString } from "oj-utils"
import { animateClassNames, animateCreate, animateRemove } from "oj-mithril-utils"
import { Icon } from "../../../components/Icon"
import { IHolder } from "../types"

export class ActionsMobile extends MithrilTsxComponent<{}> {
  view(v) {
    const side = State.getSide()

    return <div className={cleanString("ActionsMobile", animateClassNames(v, "fade-from-top"))}>
      <div className="btn-row">
        {!State.getUrlData().embossed && <button className="icon" onclick={e => State.addHolder("text")}><Icon icon="text_format" /><span>Add text</span></button>}
        <button className="icon" onclick={e => State.addHolder("image")}><Icon icon="image" /><span>Add image</span></button>
      </div>

      <div className="btn-row">
        <button className="primary icon" onclick={e => State.toCart()}><Icon icon="shopping_cart" /><span>Add to cart</span></button>
      </div>

      {side.holderIndex !== undefined && <ActionBarMobile />}
    </div>
  }

  oncreate(v) {
    animateCreate(v)
  }

  onbeforeremove(v) {
    return animateRemove(v)
  }
}

export class ActionsDesktop extends MithrilTsxComponent<{}> {
  holder: IHolder
  timer: any

  view(v) {
    return <div className={cleanString("ActionsDesktop", animateClassNames(v, "fade-from-left-to-right"))}>
      <div>
        <div className="btn-row add">
          {!State.getUrlData().embossed && <button className="icon" onclick={e => State.addHolder("text")}><Icon icon="text_format" /><span>Add text</span></button>}
          <button className="icon" onclick={e => State.addHolder("image")}><Icon icon="image" /><span>Add image</span></button>
        </div>
      </div>

      {this.holder && <ActionBarDesktop />}

      <div className="fixed-actions">
        <button className="contact" onclick={State.showContactDialog}><Icon icon="contact_support" /></button>
        <button className="primary icon" onclick={e => State.toCart()}><Icon icon="shopping_cart" /><span>Add to cart</span></button>
      </div>
    </div>
  }

  oninit(v) {
    this.holder = State.getHolder()
  }

  onbeforeupdate(v, o) {
    const holder = State.getHolder()
    if (this.holder === holder)
      return

    if (!holder || !this.holder) {
      this.holder = holder
    }
    else {
      this.holder = undefined
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.holder = State.getHolder()
        m.redraw()
      }, 200)
    }
  }

  oncreate(v) {
    animateCreate(v)
  }

  onbeforeremove(v) {
    return animateRemove(v)
  }
}